/* ============================================================
   BusterPro Cart Page
   ============================================================ */

(function () {
  'use strict';

  var STRINGING_KEYS = ['Setup', 'String', 'Mains String', 'Crosses String', 'Mains Tension', 'Crosses Tension', 'String Savers'];
  var UPSELL_PAGE_SIZE = 4;
  var upsellStates = new WeakMap();

  function getRoot() {
    return document.getElementById('bp-cart-page-root');
  }

  function escHtml(str) {
    return String(str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function qsa(sel, ctx) {
    return Array.from((ctx || document).querySelectorAll(sel));
  }

  function setLoading(isLoading) {
    var root = getRoot();
    if (root) root.classList.toggle('is-loading', isLoading);
  }

  function showCartNotice(message) {
    var notice = document.getElementById('BpCartPageNotice');
    if (!notice) return;
    notice.textContent = message || '';
    notice.hidden = !message;
  }

  function parseSection(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(selector);
  }

  function publishCartUpdate(cart) {
    document.dispatchEvent(new CustomEvent('bp:cart:refresh', { detail: cart }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

    if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish === 'function') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bp-cart-page', cartData: cart });
    }
  }

  function refreshCartPage() {
    var root = getRoot();
    var sectionId = root ? root.getAttribute('data-section-id') : 'bp-cart-page';

    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId))
      .then(function (response) {
        if (!response.ok) throw new Error('section refresh failed');
        return response.text();
      })
      .then(function (html) {
        var nextRoot = parseSection(html, '#bp-cart-page-root');
        root = getRoot();
        if (nextRoot && root) root.replaceWith(nextRoot);
      });
  }

  function refreshHeaderBubble() {
    var headerCart = document.getElementById('cart-icon-bubble');
    if (!headerCart) return Promise.resolve();

    return fetch('/?sections=cart-icon-bubble', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart bubble refresh failed');
        return response.json();
      })
      .then(function (sections) {
        if (sections && sections['cart-icon-bubble']) {
          headerCart.innerHTML = sections['cart-icon-bubble'];
        }
      })
      .catch(function () {});
  }

  function injectStringingProps(cart) {
    if (!cart || !cart.items) return;
    var root = getRoot();
    if (!root) return;
    qsa('.bp-cart-item[data-line]', root).forEach(function (article) {
      if (article.querySelector('.bp-cart-item__options--stringing')) return;
      var lineNum = parseInt(article.getAttribute('data-line'), 10);
      if (!lineNum) return;
      var item = cart.items[lineNum - 1];
      if (!item || !item.properties) return;
      var props = item.properties;
      var stringingRows = STRINGING_KEYS.filter(function (k) {
        return props[k] !== undefined && props[k] !== null && String(props[k]).trim() !== '';
      });
      if (!stringingRows.length) return;
      var html = '<div class="bp-cart-item__options bp-cart-item__options--stringing">' +
        '<p class="bp-cart-item__options-title">Stringing</p>' +
        stringingRows.map(function (k) {
          return '<p>' + escHtml(k) + ': ' + escHtml(String(props[k])) + '</p>';
        }).join('') +
        '</div>';
      var details = article.querySelector('.bp-cart-item__details');
      if (details) details.insertAdjacentHTML('beforeend', html);
    });
  }

  function renderStringingProperties() {
    // Read cart data embedded by Liquid — zero network cost
    var dataEl = document.getElementById('bp-cart-data');
    if (dataEl) {
      try {
        injectStringingProps(JSON.parse(dataEl.textContent));
        return;
      } catch (e) {}
    }
    // Fallback: fetch if embedded data is missing
    fetch('/cart.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(injectStringingProps)
      .catch(function () {});
  }

  function refreshAll(cart) {
    return Promise.all([refreshCartPage(), refreshHeaderBubble()]).then(function () {
      publishCartUpdate(cart);
      renderStringingProperties();
      initUpsellCarousels();
    });
  }

  function getUpsellState(section) {
    var state = upsellStates.get(section);
    if (state) return state;

    var collectionHandles = (section.getAttribute('data-upsell-collections') || '')
      .split('|')
      .filter(Boolean)
      .filter(function (handle, index, handles) { return handles.indexOf(handle) === index; });
    var seen = new Set((section.getAttribute('data-cart-handles') || '').split('|').filter(Boolean));
    qsa('.bp-cart-upsell-card[data-product-handle]', section).forEach(function (card) {
      seen.add(card.getAttribute('data-product-handle'));
    });

    state = {
      collectionHandles: collectionHandles,
      collectionIndex: 0,
      pages: collectionHandles.map(function () { return 1; }),
      currentCollectionDone: false,
      queue: [],
      seen: seen,
      loading: false,
      exhausted: collectionHandles.length === 0,
    };
    upsellStates.set(section, state);
    return state;
  }

  function upsellMetrics(section) {
    var track = section.querySelector('[data-bp-cart-upsell-track]');
    var card = track ? track.querySelector('.bp-cart-upsell-card') : null;
    if (!track || !card) return null;
    var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
    var step = card.getBoundingClientRect().width + gap;
    var visible = Math.max(1, Math.round((track.clientWidth + gap) / step));
    var index = Math.max(0, Math.round(track.scrollLeft / step));
    var count = track.querySelectorAll('.bp-cart-upsell-card').length;
    return { track: track, step: step, visible: visible, index: index, count: count, maxIndex: Math.max(0, count - visible) };
  }

  function updateUpsellCarousel(section) {
    if (!section) return;
    var state = getUpsellState(section);
    var metrics = upsellMetrics(section);
    var prev = section.querySelector('[data-bp-cart-action="upsell-prev"]');
    var next = section.querySelector('[data-bp-cart-action="upsell-next"]');
    if (!metrics) return;

    var canAdvance = metrics.index < metrics.maxIndex || !state.exhausted;
    section.classList.toggle('has-no-overflow', !canAdvance && metrics.maxIndex === 0);
    section.classList.toggle('is-loading-more', state.loading);
    if (prev) prev.disabled = state.loading || metrics.index === 0;
    if (next) next.disabled = state.loading || !canAdvance;
  }

  function normalizeUpsellTags(tags) {
    if (Array.isArray(tags)) return tags;
    return String(tags || '').split(',').map(function (tag) { return tag.trim(); });
  }

  function firstUpsellVariant(product) {
    return (product.variants || []).find(function (variant) { return variant.available; });
  }

  function formatUpsellPrice(price, currency) {
    var amount = parseFloat(price);
    if (!Number.isFinite(amount)) amount = 0;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: currency || 'USD'
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function upsellImageUrl(product) {
    var image = product.images && product.images[0];
    var src = typeof image === 'string' ? image : image && image.src;
    return src ? src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=360' : '';
  }

  function upsellCardHtml(product, variant, currency, addLabel, chooseLabel) {
    var url = '/products/' + encodeURIComponent(product.handle);
    var image = upsellImageUrl(product);
    var defaultVariant = product.variants.length === 1 && variant.title === 'Default Title';
    var action = defaultVariant
      ? '<button class="bp-cart-upsell-card__button" type="button" data-bp-cart-action="add-upsell" data-variant-id="' + variant.id + '">' + escHtml(addLabel || '+ Add') + '</button>'
      : '<a class="bp-cart-upsell-card__button" href="' + url + '">' + escHtml(chooseLabel || 'Choose') + '</a>';

    return '<article class="bp-cart-upsell-card" data-product-handle="' + escHtml(product.handle) + '">' +
      '<a class="bp-cart-upsell-card__media" href="' + url + '" tabindex="-1" aria-hidden="true">' +
        (image ? '<img src="' + escHtml(image) + '" alt="' + escHtml(product.title) + '" width="180" height="225" loading="lazy">' : '') +
      '</a>' +
      '<div class="bp-cart-upsell-card__info">' +
        (product.vendor ? '<p class="bp-cart-page__label">' + escHtml(product.vendor) + '</p>' : '') +
        '<a class="bp-cart-upsell-card__title" href="' + url + '">' + escHtml(product.title) + '</a>' +
        '<p class="bp-cart-upsell-card__price">' + formatUpsellPrice(variant.price, currency) + '</p>' +
      '</div>' + action +
    '</article>';
  }

  function nextQueuedUpsell(section, state) {
    while (state.queue.length) {
      var product = state.queue.shift();
      if (!product.handle || state.seen.has(product.handle)) continue;
      state.seen.add(product.handle);
      var hideTagged = section.getAttribute('data-hide-tagged') === 'true';
      var hiddenTag = section.getAttribute('data-hidden-tag') || 'hide-online-store';
      if (hideTagged && normalizeUpsellTags(product.tags).indexOf(hiddenTag) !== -1) continue;
      var variant = firstUpsellVariant(product);
      if (variant) return { product: product, variant: variant };
    }
    return null;
  }

  function loadOneUpsell(section, state) {
    var queued = nextQueuedUpsell(section, state);
    if (queued) return Promise.resolve(queued);

    if (state.currentCollectionDone) {
      state.collectionIndex += 1;
      state.currentCollectionDone = false;
    }
    if (state.collectionIndex >= state.collectionHandles.length) {
      state.exhausted = true;
      return Promise.resolve(null);
    }

    var index = state.collectionIndex;
    var handle = state.collectionHandles[index];
    var page = state.pages[index]++;
    var url = '/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + UPSELL_PAGE_SIZE + '&page=' + page;

    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('upsell request failed');
        return response.json();
      })
      .then(function (data) {
        var products = data && data.products ? data.products : [];
        state.queue = state.queue.concat(products);
        if (products.length < UPSELL_PAGE_SIZE) state.currentCollectionDone = true;
        var candidate = nextQueuedUpsell(section, state);
        return candidate || loadOneUpsell(section, state);
      });
  }

  function initUpsellCarousels() {
    qsa('.bp-cart-upsell-section').forEach(function (section) {
      var track = section.querySelector('[data-bp-cart-upsell-track]');
      if (!track) return;
      getUpsellState(section);
      if (!track.dataset.carouselInitialized) {
        track.dataset.carouselInitialized = 'true';
        track.addEventListener('scroll', function () {
          window.requestAnimationFrame(function () { updateUpsellCarousel(section); });
        }, { passive: true });
      }
      updateUpsellCarousel(section);
    });
  }

  function moveUpsellCarousel(actionEl, direction) {
    var section = actionEl.closest('.bp-cart-upsell-section');
    var state = section ? getUpsellState(section) : null;
    var metrics = section ? upsellMetrics(section) : null;
    if (!section || !state || !metrics || state.loading) return;

    if (direction < 0 || metrics.index < metrics.maxIndex) {
      metrics.track.scrollTo({ left: Math.max(0, metrics.index + direction) * metrics.step, behavior: 'smooth' });
      return;
    }
    if (state.exhausted) return;

    state.loading = true;
    updateUpsellCarousel(section);
    loadOneUpsell(section, state)
      .then(function (candidate) {
        if (!candidate) return;
        var currency = section.getAttribute('data-currency') || 'USD';
        var addLabel = section.getAttribute('data-add-label') || '+ Add';
        var chooseLabel = section.getAttribute('data-choose-label') || 'Choose';
        metrics.track.insertAdjacentHTML('beforeend', upsellCardHtml(candidate.product, candidate.variant, currency, addLabel, chooseLabel));
        window.requestAnimationFrame(function () {
          var nextMetrics = upsellMetrics(section);
          if (nextMetrics) nextMetrics.track.scrollTo({ left: (metrics.index + 1) * nextMetrics.step, behavior: 'smooth' });
        });
      })
      .catch(function () {})
      .finally(function () {
        state.loading = false;
        updateUpsellCarousel(section);
      });
  }

  function getCartItemProp(item, key) {
    var props = item.properties;
    if (!props) return null;
    if (Array.isArray(props)) {
      var entry = props.find(function (p) { return (p.name || p[0]) === key; });
      return entry ? (entry.value !== undefined ? entry.value : entry[1]) : null;
    }
    return props[key] !== undefined ? props[key] : null;
  }

  function removeLineWithGroup(line) {
    var dataEl = document.getElementById('bp-cart-data');
    var cart = null;
    try { if (dataEl) cart = JSON.parse(dataEl.textContent); } catch (e) {}

    if (!cart) { changeQuantity(line, 0); return; }

    var item    = cart.items[line - 1];
    var groupId = item ? getCartItemProp(item, '_Stringing group') : null;

    if (!groupId) { changeQuantity(line, 0); return; }

    var linesToRemove = [];
    cart.items.forEach(function (cartItem, idx) {
      if (getCartItemProp(cartItem, '_Stringing group') === groupId) {
        linesToRemove.push(idx + 1);
      }
    });
    linesToRemove.sort(function (a, b) { return b - a; });

    setLoading(true);
    linesToRemove.reduce(function (promise, lineNum) {
      return promise.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: lineNum, quantity: 0 }),
        }).then(function (r) { return r.ok ? r.json() : null; });
      });
    }, Promise.resolve())
      .then(function () { return fetch('/cart.js').then(function (r) { return r.ok ? r.json() : null; }); })
      .then(refreshAll)
      .catch(function () {})
      .finally(function () { setLoading(false); });
  }

  function changeQuantity(line, quantity, options) {
    options = options || {};
    showCartNotice('');
    setLoading(true);

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        line: parseInt(line, 10),
        quantity: Math.max(0, parseInt(quantity, 10) || 0)
      })
      })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) {
            var error = new Error(data.description || data.message || 'cart change failed');
            error.inventory = response.status === 422;
            throw error;
          }
          return data;
        });
      })
      .then(function (cart) {
        var updatedItem = cart.items && cart.items[parseInt(line, 10) - 1];
        var reachedMaximum = options.increase && updatedItem && updatedItem.quantity < quantity;
        return refreshAll(cart).then(function () {
          if (reachedMaximum) {
            showCartNotice('The maximum available quantity for this item is already in your cart.');
          }
        });
      })
      .catch(function (error) {
        if (options.increase && error.inventory) {
          showCartNotice('The maximum available quantity for this item is already in your cart.');
        } else {
          showCartNotice('We could not update this item. Please try again.');
        }
      })
      .finally(function () {
        setLoading(false);
      });
  }

  function addUpsell(variantId, button) {
    if (!variantId) return;

    setLoading(true);
    if (button) button.disabled = true;

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart add failed');
        return fetch('/cart.js');
      })
      .then(function (response) {
        if (!response.ok) throw new Error('cart fetch failed');
        return response.json();
      })
      .then(refreshAll)
      .catch(function () {
        if (button) button.disabled = false;
      })
      .finally(function () {
        setLoading(false);
      });
  }

  function getPromoInput() {
    return document.getElementById('BpCartPromo');
  }

  function getDiscountInput() {
    return document.getElementById('BpCartDiscountCode');
  }

  function getPromoFeedback() {
    return document.getElementById('BpCartPromoFeedback');
  }

  function getPromoMessage(name) {
    var root = getRoot();
    if (!root) return '';
    return root.getAttribute(name) || '';
  }

  function showPromoFeedback(message, isError) {
    var feedback = getPromoFeedback();
    if (!feedback) return;

    feedback.textContent = message;
    feedback.hidden = false;
    feedback.classList.toggle('is-error', !!isError);
  }

  function syncDiscountCode(showFeedback) {
    var input = getPromoInput();
    var hidden = getDiscountInput();
    if (!input || !hidden) return '';

    var code = input.value.trim();
    hidden.value = code;

    if (showFeedback) {
      if (code) {
        showPromoFeedback(getPromoMessage('data-promo-applied-message'), false);
      } else {
        showPromoFeedback(getPromoMessage('data-promo-empty-message'), true);
      }
    }

    return code;
  }

  function primeShopifyDiscountSession(code) {
    if (!code) return;

    fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart', {
      credentials: 'same-origin',
      redirect: 'manual'
    }).catch(function () {});
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.id !== 'cart') return;
    syncDiscountCode(false);
  }, true);

  document.addEventListener('click', function (event) {
    var actionEl = event.target.closest('[data-bp-cart-action]');
    if (!actionEl || !getRoot() || !getRoot().contains(actionEl)) return;

    var action = actionEl.getAttribute('data-bp-cart-action');

    if (action === 'upsell-prev' || action === 'upsell-next') {
      event.preventDefault();
      moveUpsellCarousel(actionEl, action === 'upsell-next' ? 1 : -1);
      return;
    }

    if (action === 'increase' || action === 'decrease') {
      event.preventDefault();
      var current = parseInt(actionEl.getAttribute('data-quantity'), 10) || 1;
      var next = action === 'increase' ? current + 1 : current - 1;
      var line = parseInt(actionEl.getAttribute('data-line'), 10);
      if (next <= 0) {
        removeLineWithGroup(line);
      } else {
        changeQuantity(line, next, { increase: action === 'increase' });
      }
      return;
    }

    if (action === 'remove') {
      event.preventDefault();
      removeLineWithGroup(parseInt(actionEl.getAttribute('data-line'), 10));
      return;
    }

    if (action === 'add-upsell') {
      event.preventDefault();
      addUpsell(actionEl.getAttribute('data-variant-id'), actionEl);
      return;
    }

    if (action === 'apply-discount') {
      event.preventDefault();
      var code = syncDiscountCode(true);
      primeShopifyDiscountSession(code);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      renderStringingProperties();
      initUpsellCarousels();
    });
  } else {
    renderStringingProperties();
    initUpsellCarousels();
  }

  window.addEventListener('resize', initUpsellCarousels);
}());
